import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { Journey } from '../../../shared/types/strings.type';
import { AnalyticsService } from '../../../shared/services/analytics/analytics.service';


@Component({
    selector: 'rttd-select-model',
    templateUrl: './select-model.component.html',
    styleUrls: ['./select-model.component.scss']
})
export class SelectModelComponent implements OnInit {

    header: Journey = {
        title: 'Book a Test Drive.',
        subtitle: 'Select the model you would like to test drive. You can cancel or change your appointment at any time.',
        //instruction: 'Select a model.',
        //link: 'Request a callback',
        //linkId: 'request-a-call-back'
        instruction: '',
        link: '',
        linkId: ''
    };

    modelFilter: string

    constructor(
        private appSettings:AppSettings,
        private analytics: AnalyticsService
    ) {

        if (appSettings.apiBrand.toLowerCase() == "bmw"){
            this.header.subtitle = "Select your vehicle below."
        }
    }

    ngOnInit() {
        this.modelFilter = this.appSettings.eventConfirmationModelSelection;

        this.analytics.setRttdForm('Select Model');
       

    }

}
